export enum QueryKey {
  TIMESHEET_HISTORY = 'TIMESHEET_HISTORY',
}
